require('./telestrateCanvasController');

angular.module('app.player.telestrate.telestrateCanvasDirective', [
  'app.player.telestrate.telestrateCanvasController'
])
  .directive('telestrateCanvas', [
    function () {
      "use strict";

      return {
        restrict: 'A',
        controller: 'app.player.telestrate.telestrateCanvasController',
        scope: {
          toolbox: '=',
          activeTab: '=',
          telestrateTab: '='
        },
        link: (scope, elm) => {
          elm.on('mousedown', scope.teleStrateStartDraw);
          elm.on('mouseup', scope.telestrateEndDraw);
          elm.on('mouseleave', scope.telestrateEndDraw);
          elm.on('mousemove', scope.telestrateDraw);

          scope.canvas = elm[0];
          scope.canvasContext = scope.canvas.getContext("2d");
        }
      }
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/player/telestrate/telestrateCanvas/telestrateCanvasDirective.js